/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { ICreateScenesGroup, IScenesGroup } from '../interfaces/scenes-group';

export class ScenesGroupService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getScenesGroupById(id: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.GET_SCENES_GROUPS,
					null,
					{ reqPathParam: id },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addScenesGroup(newScenesGroupData: IScenesGroup) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.CREATE_SCENES_GROUP,
					this.formatScenesGroupReqData(newScenesGroupData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateScenesGroup(sceneTagToUpdateData: IScenesGroup) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.UPDATE_SCENES_GROUP,
					this.formatScenesGroupReqData(sceneTagToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getScenesGroups(page: number, { searchKey = '' }: { searchKey: string }) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.GET_SCENES_GROUPS,
					{},
					{
						pathParams: { page: page || 1, searchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	searchScenesGroupsAutoComplete({ searchKey }: { searchKey: string }) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().SCENE_MATCHING
						.SEARCH_SCENES_GROUPS,
					{},
					{
						pathParams: {
							searchKey,
						},
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	deleteScenesGroup(id: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().SCENE_MATCHING.DELETE_SCENES_GROUP,
			null,
			{ reqPathParam: id },
		);
	}

	private formatScenesGroupReqData({
		id,
		name,
		orderedScenesTags,
		scenesCards,
		tagsPerScene,
	}: IScenesGroup): ICreateScenesGroup {
		return {
			...(id ? { id } : {}),
			name,
			tagsPerScene,
			orderedScenesTagsIds: orderedScenesTags.map(tag => tag.id),
			scenesCardsIds: scenesCards.map(card => card.id as number),
		};
	}
}
